var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef, ElementRef, EventEmitter, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { PageNames } from '../../shared/page-names.enum';
import { Router } from '@angular/router';
import { TvShopEntertainmentPack } from '../../model/tv-shop-entertainment-pack';
import { SelectableNavigationItem } from '../../model/selectable-navigation-item';
import { ImageUtils } from '../../shared/utils/image/image-utils';
import { CarouselService } from '../../services/carousel/carousel.service';
import { takeUntil } from 'rxjs/operators';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
var NavigableBannerComponent = /** @class */ (function (_super) {
    __extends(NavigableBannerComponent, _super);
    function NavigableBannerComponent(navigationService, router, carouselService, changeDetector, stateService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.router = router;
        _this.carouselService = carouselService;
        _this.changeDetector = changeDetector;
        _this.stateService = stateService;
        _this.selectedCarouselItem = new EventEmitter();
        _this.y = 0;
        return _this;
    }
    NavigableBannerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.navigationService.registerNavigation(this, PageNames.HOMEPAGE);
        this.carouselService.highlightedImages$.pipe(takeUntil(this.stopSubscription)).subscribe(function (imageArray) {
            if (imageArray && _this.bannerDiv) {
                _this.bannerDiv.nativeElement.appendChild(imageArray[_this.carouselService.highlightedOmapiId + '-banner']);
                _this.logoDiv.nativeElement.appendChild(imageArray[_this.carouselService.highlightedOmapiId + '-logo']);
            }
        });
    };
    NavigableBannerComponent.prototype.onEnter = function () {
        this.stateService.setSelectedTvShopEntertainmentPack(this.pack);
        this.router.navigate(['/product-details/' + this.pack.omapiId], { queryParamsHandling: 'merge' });
    };
    Object.defineProperty(NavigableBannerComponent.prototype, "omapiId", {
        get: function () {
            if (this.pack) {
                return this.pack.omapiId;
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavigableBannerComponent.prototype, "omapiIdForTitle", {
        get: function () {
            if (this.pack) {
                return OmapiIdsUtils.getCorrectIdForResource(this.pack.omapiId);
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    NavigableBannerComponent.prototype.activate = function (active) {
        this.active = active;
        if (this.active) {
            this.selectedCarouselItem.emit(this);
        }
        this.changeDetector.detectChanges();
    };
    NavigableBannerComponent.prototype.onBack = function () {
        window.close();
    };
    Object.defineProperty(NavigableBannerComponent.prototype, "logoUrl", {
        get: function () {
            return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
        },
        enumerable: true,
        configurable: true
    });
    NavigableBannerComponent.prototype.isRedCarpetOrRedCarpetMore = function () {
        return (OmapiIdConstants.STREAMZ === this.carouselService.highlightedOmapiId || this.carouselService.highlightedOmapiId === OmapiIdConstants.RED_CARPET_MORE);
    };
    return NavigableBannerComponent;
}(SelectableNavigationItem));
export { NavigableBannerComponent };
